import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scrollY: 0,
    wheelDirection: null,
    cursorChange: false,
    mouseEvent: null,
    isWheelDisabled: false,
    home: false
  },
  mutations: {
    scroll (state, prop) {
      state.scrollY = prop.y
    },
    wheel (state, prop) {
      state.wheelDirection = prop.direction
    },
    cursorChange (state, prop) {
      state.cursorChange = prop.show;
      state.mouseEvent = prop.event;
    },
    disableWheel (state, prop) {
      state.isWheelDisabled = prop.wheel
    },
    toHome (state, prop) {
      state.home = prop.home
    }
  }
})
